import { PaginationType } from 'common';
import { UsersActionType } from 'enums';
import { UserType } from 'state/reducers/auth/types';

export const setUsers = (users: UserType[]) =>
  ({ type: UsersActionType.SET_USERS, users } as const);

export const setCertainUser = (certainUser: UserType) =>
  ({ type: UsersActionType.SET_CERTAIN_USER, certainUser } as const);

export const setUsersAfterScroll = (users: UserType[]) =>
  ({ type: UsersActionType.SET_USERS_AFTER_SCROLL, users } as const);

export const searchUser = (search: string) =>
  ({ type: UsersActionType.SEARCH_USER, search } as const);

export const setUsersLoadingStatus = (isLoading: boolean) =>
  ({ type: UsersActionType.SET_USERS_LOADING_STATUS, isLoading } as const);

export const setPagination = (pagination: PaginationType) =>
  ({ type: UsersActionType.SET_PAGINATION, pagination } as const);
